import { clsx } from "clsx";
import React from "react";
import styles from "./Description.module.less";

interface DescriptionProps {
    content?: string;
}
export const Description: React.FC<DescriptionProps> = ({ content }) => {
    if (!content) return null;

    return (
        <>
            <div className={clsx(styles.title, "sectionTitle")}>Description</div>
            <div className={styles.content}>{content}</div>
        </>
    );
};
